import { jsxs as v, jsx as o } from "react/jsx-runtime";
import { EnvironmentService as M } from "../../helpers/services/environmentService/environmentService.js";
import B from "../../hooks/useMegaMenu.js";
import { Login as E } from "../Login/Login.js";
import "../Login/context.js";
import I from "../NavBar/NavBar.js";
import { SideNav as L } from "../SideNav/SideNav.js";
import { Wrapper as W, MobileNavigation as b, LogoWrapper as j, DesktopNavigation as C, NavBarWrapper as a, LoginButton as w } from "./styled.js";
const y = ({
  client_id: t = "",
  redirect_uri: i = "",
  post_logout_redirect_uri: e = void 0,
  loginUrl: s = "",
  authStore: p,
  linkTarget: f,
  showHeader: l = !0,
  showLogin: d = !1,
  showSideNav: h = !1,
  navItems: c = [],
  fetchItemsFromAPI: N = !1,
  megamenu: r
}) => {
  const { items: x } = B(
    (r == null ? void 0 : r.fetchItemsFromAPI) ?? N,
    (r == null ? void 0 : r.useCache) ?? !0,
    (r == null ? void 0 : r.env) ?? (r != null && r.useCurrentEnvironment ? M.currentEnvironment : "prod")
  ), n = x ?? c;
  return l ? /* @__PURE__ */ v(W, { role: "banner", children: [
    h && /* @__PURE__ */ o(b, { children: /* @__PURE__ */ o(
      L,
      {
        loginUrl: s,
        client_id: t,
        redirect_uri: i,
        linkTarget: f,
        authStore: p,
        items: n
      }
    ) }),
    /* @__PURE__ */ o(j, { text: "The new place to go for government services" }),
    /* @__PURE__ */ v(C, { children: [
      /* @__PURE__ */ o(a, { children: c && /* @__PURE__ */ o(I, { items: n }) }),
      /* @__PURE__ */ o(w, { children: d && /* @__PURE__ */ o(
        E,
        {
          client_id: t,
          loginUrl: s,
          redirect_uri: i,
          post_logout_redirect_uri: e,
          linkTarget: f,
          authStore: p
        }
      ) })
    ] })
  ] }) : null;
};
export {
  y as default
};
